import {GET_VALUATOR} from '../constants/ActionTypes'

const INIT_STATE = {
    valuatorId: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_VALUATOR:
            return {
                valuatorId: action.body,
                loading :false
            }
        default:
            return state;
    }
}